<template>
  <vs-row vs-justify="center" class="mt-3">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <!-- <h3 class="card-title d-flex">
          Register Apps
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addNewApp">Add New App</vs-button>
        </h3>
        <p class="card-subtitle">List of Registered Apps used for Promotions</p> -->
      <vs-row>
        <vs-select :color="colorx" label="Language Filter" v-model="language" @change="searchData()">
          <vs-select-item value text="Select Language" disabled />
          <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
        </vs-select>
        <!-- <vs-col vs-lg="3" vs-xs="12">
            <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()" icon="search">Search</vs-button>
          </vs-col> -->
      </vs-row>
      <br />
      <table class="table">
        <tr>
          <th>#</th>
          <th>Title</th>
          <th>App Key</th>
          <th>Bundle Id</th>
          <th>App URL</th>
          <th>Icon URL</th>
          <th>Banner URL</th>
          <th>Status</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in all" :key="item.culture">
          <td class="td">{{ index + 1 }}</td>
          <td class="td">
            <h6>{{ item.title }} ({{ item.language }})</h6>
            <small>{{ item.description }}</small>
          </td>
          <td style="font-family: monospace; font-size: 10px">
            {{ item.guid }}
          </td>
          <td style="font-family: monospace; font-size: 10px">
            {{ item.bundleId }}
          </td>
          <td class="td">
            <span class="material-icons" style="cursor: pointer" @click="viewAppURL(item)">remove_red_eye</span>
          </td>
          <td class="td">
            <img v-if="item.iconURL == '' || item.iconURL == null" src="../../../../assets/images/No-image.png" height="50px" width="75px" />
            <img v-else :src="item.iconURL" height="50px" width="75px" />
          </td>
          <td class="td">
            <img v-if="item.bannerURL == '' || item.bannerURL == null" src="../../../../assets/images/No-image.png" height="50px" width="75px" />
            <img v-else :src="item.bannerURL" height="50px" width="75px" />
          </td>
          <td class="td">
            <vs-chip v-if="item.status" color="success">Active</vs-chip>
            <vs-chip v-else color="danger">Inactive</vs-chip>
          </td>
          <td class="td">
            <vs-dropdown>
              <vs-icon class icon="more_vert"></vs-icon>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="editingItem(item)"> <vs-icon class="align-right" icon="create"></vs-icon>Edit </vs-dropdown-item>
                <vs-dropdown-item
                  @click="
                    deleteAppPopup = true;
                    itemToDelete = item;
                  "
                >
                  <vs-icon class icon="delete_sweep"></vs-icon>Delete
                </vs-dropdown-item>
                <vs-dropdown-item
                  @click="
                    promoteAppPopup = true;
                    itemToPromote = item;
                  "
                >
                  <vs-icon class icon="star"></vs-icon>Promote
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </td>
        </tr>
      </table>

      <!-- Code -->
      <vs-popup :title="isNew ? 'Add New App' : 'Edit App'" :active.sync="defaultalert">
        <vs-row>
          <vs-col vs-lg="12" vs-xs="12">
            <vs-input label="App Title (Keep it Simple and short)" v-model="app.title" />
          </vs-col>
          <vs-col vs-lg="12" vs-xs="12">
            <label>App Description</label>
            <vs-textarea v-model="app.description" />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12" class="mb15">
            <vs-select :color="colorx" label="Language Filter" v-model="app.language">
              <vs-select-item value text="Select Language" disabled />
              <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12" class="checkbox">
            <vs-checkbox v-model="app.status">Status (Active / Inactive)</vs-checkbox>
          </vs-col>
          <vs-col vs-lg="12" vs-xs="12">
            <vs-input label="Bundle Id" v-model="app.bundleId" />
          </vs-col>
          <vs-col vs-lg="12" vs-xs="12">
            <vs-input label="App URL" v-model="app.appURL" />
          </vs-col>
          <!-- <vs-col vs-lg="12" vs-xs="12">
              <uploader label="Icon Url" v-model="app.iconURL" :file="app.iconURL" />
            </vs-col> -->
          <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
            <div>
              <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                <div class="upload-btn-wrapper vs-input-primary">
                  <label class="vs-input--label">Icon Url</label>
                  <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                  <input type="file" ref="fileInput" @change="uploadImage($event, 'appURL')" />
                </div>
              </vs-col>
              <vs-col v-if="displayImage">
                <label class="vs-input--label">Icon Url</label><br />
                <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage('appURL')"></vs-button>
                <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                <b>File Name : {{ fileName }}</b>
              </vs-col>
            </div>
          </vs-col>
          <!-- <vs-col vs-lg="12" vs-xs="12">
              <uploader
                label="Banner Url"
                v-model="app.bannerURL"
                :file="app.bannerURL"
              />
            </vs-col> -->
          <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
            <div>
              <vs-col vs-lg="12" vs-xs="12" v-if="displayBannerImage == ''">
                <div class="upload-btn-wrapper vs-input-primary">
                  <label class="vs-input--label">Banner Url</label>
                  <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                  <input type="file" ref="fileInput" @change="uploadImage($event, 'bannerURL')" />
                </div>
              </vs-col>
              <vs-col v-if="displayBannerImage">
                <label class="vs-input--label">Banner Url</label><br />
                <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage('bannerURL')"></vs-button>
                <img :src="displayBannerImage" class="imgUp" height="100px" width="150px" />
                <b>File Name : {{ fileNameBanner }}</b>
              </vs-col>
            </div>
          </vs-col>
          <vs-col vs-lg="12" vs-xs="12" class="mt-3">
            <vs-button @click="btnAddApp" icon="save">Save App</vs-button>
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup title="Delete App" :active.sync="deleteAppPopup">
        <p>Are you sure you want to delete App?</p>
        <div>
          <vs-button icon="delete_forever" class="mr15" @click="deleteApp">Delete App</vs-button>
          <vs-button icon="clear" @click="deleteAppPopup = false">Cancel</vs-button>
        </div>
      </vs-popup>

      <vs-popup v-if="promoteAppPopup" :title="popupTitle + ' for ' + itemToPromote.title" :active.sync="promoteAppPopup">
        <vs-button
          icon="create"
          color="primary"
          type="border"
          id="tab-button-insert"
          class="app-button"
          @click="selectedComponent = 'insertPromote'"
          :class="selectedComponent == 'insertPromote' ? 'colored' : ''"
          popupTitle="Insert Promotion Apps"
          >Insert Promotion App</vs-button
        >
        <vs-button
          color="primary"
          icon="view_list"
          id="tab-button-view"
          type="border"
          @click="
            selectedComponent = 'viewPromote';
            popupTitle = 'View Promoted Apps';
          "
          :class="selectedComponent == 'viewPromote' ? 'colored' : ''"
          >View Promoted Apps</vs-button
        >
        <component
          @promoted-object="promoteObject"
          :editObject="editObject"
          :is="selectedComponent"
          :itemToPromote="itemToPromote"
          :languageSelect="language"
          @delete-promoted-item="deletePromotedAppProp"
        />
      </vs-popup>

      <vs-popup class="holamundo" title="Delete Promoted App" :active.sync="deletePromotedAppPopup">
        <p>Are you sure you want to delete Promoted App?</p>
        <div>
          <vs-button icon="delete_forever" class="mr15" @click="deletePromotedApp">Delete Promoted App</vs-button>
          <vs-button icon="clear" @click="deletePromotedAppPopup = false">Cancel</vs-button>
        </div>
      </vs-popup>

      <vs-popup title="View APP URL" :active.sync="viewAppURLPopup">
        <div v-html="appURL"></div>
      </vs-popup>
      <!-- Code -->
    </vs-col>
  </vs-row>
</template>

<script>
import uploader from "../../common/uploader";
import api from "@/rest.js";
import { API } from "@/common/constants";
import insertPromote from "../insertPromotedApps.vue";
import viewPromote from "../viewPromotedApps.vue";

export default {
  name: "App",
  components: {
    uploader,
    insertPromote,
    viewPromote,
  },
  data: () => ({
    title: "App",
    colorx: "#0D2144",
    popupTitle: "Insert Promotion App",
    defaultalert: false,
    deleteAppPopup: false,
    promoteAppPopup: false,
    deletePromotedAppPopup: false,
    selectedComponent: "insertPromote",
    seeReviews: false,
    isNew: true,
    itemToDelete: "",
    itemToUpdate: "",
    itemToPromote: {},
    appURL: "",
    viewAppURLPopup: false,
    promotedAppDeleteItem: "",
    app: {
      language: "",
    },
    all: [],
    language: "EN",
    languages: [],
    editObject: null,
    displayImage: "",
    fileName: "",
    displayBannerImage: "",
    fileNameBanner: "",
  }),
  methods: {
    searchData() {
      this.fetchAllApps(this.$data.language);
    },
    addNewApp() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.app = {
        language: "",
      };
      this.$data.displayImage = "";
      this.$data.displayBannerImage = "";
    },
    editingItem(i) {
      this.$data.app = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage = i.iconURL;
      this.$data.displayBannerImage = i.bannerURL;
    },
    uploadImage(data, item) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      if (item == "appURL") {
        this.$data.fileName = data.target.files[0].name;
      } else {
        this.$data.fileNameBanner = data.target.files[0].name;
      }
      formdata.append("file", data.target.files[0]);
      formdata.append("app", this.$data.app.name);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            if (response && response.data && response.data.files.length) {
              if (item == "appURL") {
                this.$data.displayImage = response.data.files[0].url;
              } else {
                this.$data.displayBannerImage = response.data.files[0].url;
              }
            }

            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    deleteImage(item) {
      if (item == "appURL") {
        this.$data.displayImage = "";
      } else {
        this.$data.displayBannerImage = "";
      }
    },
    btnAddApp() {
      let apiToCall = API.INSERT_APP;
      let data = this.$data.app;
      this.$data.app.iconURL = this.$data.displayImage;
      this.$data.app.bannerURL = this.$data.displayBannerImage;

      if (this.$data.app.title == "" || this.$data.app.title == undefined) {
        this.$vs.notify({
          title: "Error",
          text: "App Title Can't be Empty",
          color: "danger",
          position: "top-right",
        });
      } else if (this.$data.app.bundleId == "" || this.$data.app.bundleId == undefined) {
        this.$vs.notify({
          title: "Error",
          text: "App BundleId Can't be Empty",
          color: "danger",
          position: "top-right",
        });
      } else if (this.$data.app.appURL == "" || this.$data.app.appURL == undefined) {
        this.$vs.notify({
          title: "Error",
          text: "App URL Can't be Empty",
          color: "danger",
          position: "top-right",
        });
      } else if (!this.$data.app.bannerURL) {
        this.$vs.notify({
          title: "Error",
          text: "App Banner URL Can't be Empty",
          color: "danger",
          position: "top-right",
        });
      } else if (this.$data.app.iconURL == "" || this.$data.app.iconURL == undefined) {
        this.$vs.notify({
          title: "Error",
          text: "App Icon URL Can't be Empty",
          color: "danger",
          position: "top-right",
        });
      } else {
        this.$vs.loading();
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };

        if (JSON.parse(localStorage.user).token) {
          headers["x-master-token"] = JSON.parse(localStorage.user).token;
        }
        if (!this.$data.isNew) {
          apiToCall = API.UPDATE_APP;
          data["iconURL"] = this.$data.displayImage;
          data["bannerURL"] = this.$data.displayBannerImage;

          api.put(`${apiToCall}/${this.$data.app._id}`, data, { headers }).then((r) => {
            this.$vs.loading.close();
            if (r.status == 200) {
              this.$vs.notify({
                title: "Success",
                text: "Updated Successfully",
                color: "success",
                position: "top-right",
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              this.$data.app = {
                language: "",
              };
              this.fetchAllApps(this.$data.language);
            } else {
              this.$vs.notify({
                title: "Error",
                text: r.data.error,
                color: "danger",
                position: "top-right",
              });
            }
          });
        } else {
          api
            .post(apiToCall, data, { headers })
            .then((r) => {
              this.$vs.loading.close();
              if (r.status == 200) {
                this.$vs.notify({
                  title: "Success",
                  text: "Saved Successfully",
                  color: "success",
                  position: "top-right",
                });
                this.$data.isNew = true;
                this.$data.itemToUpdate = "";
                this.$data.defaultalert = false;
                this.$data.app = {
                  language: "",
                };
                this.fetchAllApps(this.$data.language);
              } else {
                this.$vs.notify({
                  title: "Error",
                  text: r.data.error,
                  color: "danger",
                  position: "top-right",
                });
              }
            })
            .catch(() => {
              this.$vs.loading.close();
            });
        }
      }
    },
    fetchAllLanguages() {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .get(API.GET_LANG, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
          if (!r.status == 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
    },
    deleteApp() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(`${API.DELETE_APP}/${this.$data.itemToDelete._id}`, { headers })
        .then((r) => {
          if (r.data.status) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteAppPopup = false;
          this.fetchAllApps(this.$data.language);
        })
        .catch(() => {});
    },
    fetchAllApps(lang) {
      this.$vs.loading();
      api
        .get(`${API.GET_APP}?language=${lang}`)
        .then((r) => {
          this.$vs.loading.close();
          this.$data.all = r.data;
          if (!r.status == 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
    },
    promoteObject(val) {
      this.selectedComponent = "insertPromote";
      this.editObject = Object.assign({}, val);
    },
    deletePromotedApp() {
      api
        .delete(`${API.DELETE_PROMOTE_APP}/${this.$data.promotedAppDeleteItem._id}`)
        .then((r) => {
          if (r.data.status) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deletePromotedAppPopup = false;
          this.$data.promoteAppPopup = false;
        })
        .catch(() => {});
    },
    deletePromotedAppProp(val) {
      this.$data.promotedAppDeleteItem = val;
      this.$data.deletePromotedAppPopup = true;
    },
    viewAppURL(i) {
      this.$data.viewAppURLPopup = true;
      this.$data.appURL = i.appURL;
    },
  },
  created() {
    this.fetchAllLanguages();
    this.fetchAllApps(this.$data.language);
  },
};
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.searchBtn {
  margin-top: 25px;
  width: 50%;
}

.checkbox {
  margin-top: 30px;
  margin-bottom: 5px;
}

.app-button {
  margin-right: 10px;
}

.colored {
  background-color: #22438a !important;
  color: white !important;
}

.colored:hover {
  background-color: #22438a !important;
  color: white !important;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.closeBtn {
  float: right;
  right: 0px;
  top: 0px;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
